<template>
  <section drivelass="section pt-5">download file</section>
</template>

<script>
export default {
  name: "DriveFileDownload",
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    console.log("uuid", uuid);
  },
  created() {},
};
</script>

<style scoped></style>
